import { Grid, Paper, styled, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Home from "../../home/Home";
import Snackbar from '../../Snacbar';

const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));

function QuotationDownload() {
  const mystyle = {
    border: " 1px solid black",
    width: "11rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };

  ///////setdetails
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [Quotation_values, setQuotation_values] = useState({
    importerName: '',
    forwarderName: '',
  });
  const importerNameChangehandle = (e) => {
    setQuotation_values({ ...Quotation_values, importerName: e.target.value, forwarderName: '' })

  };
  const forwarderNameChangehandle = (e) => {
    setQuotation_values({ ...Quotation_values, forwarderName: e.target.value, importerName: '' })
  };
  ///keydown
  const importerNamekeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('frwdrName').focus()
    }
  }

  ////
  const handleClose = () => {
    setOpen(false)
  }
  ///getFunction
  const getimportername = () => {
    BillingReportsService.getImporterDetails().then(res => {
      setdetails1(res.data);
    })
  }
  const selectFwdDetails = () => {
    BillingReportsService.selectFwdDetails().then(res => {
      setdetails2(res.data);
    })
  }
  const quotationPdfPrint = () => {
    var fwdId, iecNo = '';
    if (Quotation_values.forwarderName === 'ALL' && Quotation_values.forwarderName === 'ALL') {
      setMessage('Select Any one Importer Or Forwarder')
      setseverit('warning')
      setOpen(true)
      document.getElementById('impID').focus();
    }
    else {
      if (Quotation_values.forwarderName !== '' && Quotation_values.forwarderName !== 'ALL') {
        fwdId = Quotation_values.forwarderName;
        iecNo = '-1'
      } else if (Quotation_values.importerName !== '' && Quotation_values.importerName !== 'ALL') {
        fwdId = '-1'
        iecNo = Quotation_values.importerName
      }
      let details = { fwdId: fwdId, iecNo: iecNo }
      console.log('values=>' + JSON.stringify(details))
      BillingReportsService.QuotationPdfPrint(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
      })
    }
  }
  useEffect(() => {
    getimportername();
    selectFwdDetails();
  }, []);
  return (
    <div>
      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Grid container>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            <ItemPap>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>QUOTATION DOWNLOAD</center></div>
              <Row>
                <Col xs={6}>
                  <label style={mystyle1}>ImporterName</label>
                </Col>
                <Col xs={6}>
                  <Form.Select size="sm" id='impID' style={mystyle} value={Quotation_values.importerName}
                    onKeyDown={importerNamekeydown} onChange={importerNameChangehandle}>
                    <option value={'ALL'}>ALL</option>
                    {details1.map(trns => (
                      <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col xs={6}>
                  <label style={mystyle1}>ForwarderName</label>
                </Col>
                <Col xs={6}>
                  <Form.Select size="sm" style={mystyle} id={'frwdrName'} value={Quotation_values.forwarderName} onChange={forwarderNameChangehandle}>
                    <option value='ALL'>ALL</option>
                    {details2.map(trns => (
                      <option value={trns.fwdId}>{trns.fwdName}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col lg={3}></Col>
                <Col lg={6}>
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={quotationPdfPrint}>
                    Downlaod Quotation
                  </Button>{" "}
                </Col>
                <Col lg={3}></Col>
              </Row>{" "}
            </ItemPap>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </div>
    </div>
  );
}

export default QuotationDownload;
